module.exports = __webpack_public_path__ + "img/extermination-resatauration.52d8a0db.jpg";